export const PLAN_UPGRADE_MODE = "one_shot_plan_upgrade";
export const PLAN_UPGRADE_DESCRIPTION = "Flow - Mejora de plan";

export interface ScheduledPlanChange {
  id: string;
  toPlan: string;
  toPlanName: string | null;
  toPrice: number | null;
  effectiveDate: string;
}

export interface PlanChangeOptions {
  ok: boolean;
  reason: string | null;
  message: string | null;
  direction: "upgrade" | "downgrade" | "lateral" | null;
  fromPlan: string | null;
  fromPlanName: string | null;
  fromPrice: number | null;
  toPlan: string | null;
  toPlanName: string | null;
  toPrice: number | null;
  difference: number;
  fromConversations: number | null;
  toConversations: number | null;
  extraConversations: number | null;
  periodEnd: string | null;
  nextChargeDate: string | null;
  daysLeft: number | null;
  thresholdDays: number | null;
  immediateAvailable: boolean;
  nextCycleAvailable: boolean;
  scheduled: ScheduledPlanChange | null;
}

export type CardChangeView = "signup" | "loading" | "refused" | "upgrade" | "next_cycle";

export function cardChangeView(
  hasPreapproval: boolean,
  options: PlanChangeOptions | null | undefined,
  loading: boolean,
): CardChangeView {
  if (!hasPreapproval) return "signup";
  if (loading) return "loading";
  if (!options) return "refused";
  if (!options.ok) return options.reason === "no_live_authorization" ? "signup" : "refused";
  if (options.immediateAvailable) return "upgrade";
  if (options.nextCycleAvailable) return "next_cycle";
  return "refused";
}

export type CardChangeKind = "immediate" | "next_cycle";

export function defaultCardChangeKind(view: CardChangeView): CardChangeKind {
  return view === "next_cycle" ? "next_cycle" : "immediate";
}

export function refusedPlanChange(message: string): PlanChangeOptions {
  return {
    ok: false,
    reason: "request_failed",
    message,
    direction: null,
    fromPlan: null,
    fromPlanName: null,
    fromPrice: null,
    toPlan: null,
    toPlanName: null,
    toPrice: null,
    difference: 0,
    fromConversations: null,
    toConversations: null,
    extraConversations: null,
    periodEnd: null,
    nextChargeDate: null,
    daysLeft: null,
    thresholdDays: null,
    immediateAvailable: false,
    nextCycleAvailable: false,
    scheduled: null,
  };
}

export function hasCardAuthorization(preapproval: { status?: string | null; mode?: string | null } | null | undefined): boolean {
  return preapproval?.status === "authorized" && (preapproval.mode ?? "subscription") === "subscription";
}
